import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "b-user-list__item__text"
}
const _hoisted_2 = {
  key: 1,
  class: "b-user-list__item__text"
}
const _hoisted_3 = {
  key: 2,
  class: "b-user-list__item-by--hover"
}
const _hoisted_4 = {
  key: 0,
  class: "b-user-list__item__text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwIcon = _resolveComponent("FwIcon")!
  const _component_WorkerAvatar = _resolveComponent("WorkerAvatar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ "b-user-list__item--active": _ctx.isActive })
  }, [
    _createElementVNode("div", {
      style: _normalizeStyle({ "backgroundColor": _ctx.userColor }),
      class: _normalizeClass(_ctx.userData.is_site ? `b-room-list__item__avatar` : `b-user-list__item__avatar`)
    }, [
      (!_ctx.userData.avatar_url)
        ? (_openBlock(), _createBlock(_component_FwIcon, {
            key: 0,
            class: "b-worker__avatar__icon",
            icon: _ctx.userData.is_site ? `icon-door` : `no-avatar`,
            size: _ctx.userData.is_site ? `15` : `10`,
            color: "#fff"
          }, null, 8, ["icon", "size"]))
        : (_openBlock(), _createBlock(_component_WorkerAvatar, {
            key: 1,
            class: "h-mv-15",
            avatarSize: 22,
            hideInfo: true,
            worker: _ctx.userData,
            size: "small",
            align: "small"
          }, null, 8, ["worker"]))
    ], 6),
    (_ctx.getName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.capitalize(_ctx.$t(_ctx.getName))), 1))
      : _createCommentVNode("", true),
    (_ctx.getLastName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.capitalize(_ctx.$t(_ctx.getLastName))), 1))
      : _createCommentVNode("", true),
    (_ctx.name)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.getName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.capitalize(_ctx.$t(_ctx.name))), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}